import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    settings: [],
});

const notification = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.NOTIFICATION_SETTINGS_GET_SUCCESS:
            return assign({}, state, payload);

        default:
            return state;
    }
};

export default notification;
